var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.overriddenTemplate)?_c('TixTemplate',{staticClass:"overridden svg-icon",attrs:{"template":_vm.overriddenTemplate,"wrapper":false}}):_c(_vm.name,{tag:"component",staticClass:"default svg-icon",attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }